module.exports = __webpack_public_path__ + "static/media/person.9f29c0c4.jpg";